import { Component } from '@angular/core';

@Component({
	selector: 'card',
	template: '<ng-content></ng-content>',
	styleUrls: ['./card.component.scss']
})
export class CardComponent {
	constructor() { }
}
